var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#EDF8FF","key":0}),React.createElement("path",{"d":"M19 53L35.9918 34.919L39.9943 46.4996L59 27M59 27L49.9858 27.444M59 27L58.4876 36.1667","stroke":"#2665F6","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowUp.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
